import PropTypes from 'prop-types'
import React from 'react'
import { observer, inject } from 'mobx-react'
import ListStore from 'react-mobx-admin/state/data_table'
import {
  Button,
  ButtonGroup,
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap'

const HistoricalDataFilter = ({ store }) => {
  return (
    <ButtonGroup className='btn-group-top-right'>
      {store.historicDataFilterActive &&
        <OverlayTrigger placement='top' overlay={<Tooltip>{store.__('History is hidden')}</Tooltip>}>
          <Button bsStyle='default' onClick={store.historicDataFilterUpdate}>{' X '}</Button>
        </OverlayTrigger>
      }
      <OverlayTrigger placement='top' overlay={<Tooltip>
        {store.historicDataFilterActive
          ? store.__('History is hidden')
          : store.__('History is displayed')
        }
      </Tooltip>}>
        <Button
          bsStyle={store.historicDataFilterActive ? 'warning' : 'default'}
          onClick={store.historicDataFilterUpdate}>
          <i className='glyphicon glyphicon-tasks' />&nbsp;{store.__('History')}
        </Button>
      </OverlayTrigger>
    </ButtonGroup>
  )
}

HistoricalDataFilter.propTypes = {
  store: PropTypes.instanceOf(ListStore).isRequired
}

export default inject('store')(observer(HistoricalDataFilter))
